module.exports = {
	"root": "findify-layouts--autocomplete--dropdown",
	"wrapper": "findify-layouts--autocomplete--dropdown__wrapper",
	"type-title": "findify-layouts--autocomplete--dropdown__type-title",
	"typeTitle": "findify-layouts--autocomplete--dropdown__type-title",
	"suggestions-title": "findify-layouts--autocomplete--dropdown__suggestions-title",
	"suggestionsTitle": "findify-layouts--autocomplete--dropdown__suggestions-title",
	"trending-title": "findify-layouts--autocomplete--dropdown__trending-title",
	"trendingTitle": "findify-layouts--autocomplete--dropdown__trending-title",
	"overlay": "findify-layouts--autocomplete--dropdown__overlay",
	"not-found": "findify-layouts--autocomplete--dropdown__not-found",
	"notFound": "findify-layouts--autocomplete--dropdown__not-found",
	"start-typing": "findify-layouts--autocomplete--dropdown__start-typing",
	"startTyping": "findify-layouts--autocomplete--dropdown__start-typing",
	"tip": "findify-layouts--autocomplete--dropdown__tip",
	"highlight": "findify-layouts--autocomplete--dropdown__highlight",
	"container": "findify-layouts--autocomplete--dropdown__container",
	"product-matches-container": "findify-layouts--autocomplete--dropdown__product-matches-container",
	"productMatchesContainer": "findify-layouts--autocomplete--dropdown__product-matches-container",
	"suggestions-container": "findify-layouts--autocomplete--dropdown__suggestions-container",
	"suggestionsContainer": "findify-layouts--autocomplete--dropdown__suggestions-container"
};